import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import middlewarePipeline from "./middlewarePipeline"
import type { Context, Middleware } from "@/common/types/router"
import { useConfig, useUser } from "@/common/store"

const guard = () => {
    return (
        to: RouteLocationNormalized,
        from: RouteLocationNormalized,
        next: NavigationGuardNext
    ) => {
        if (!to.meta.middleware) {
            return next()
        }

        const middleware = to.meta.middleware as Middleware[]
        const context: Context = { to, from, next, useUser, useConfig }

        middleware[0]({
            ...context,
            nextMiddleware: middlewarePipeline(context, middleware, 1)
        })
    }
}

export default guard
